import React from "react";

import type { HeaderContent } from ".";
import { ScrollDirection } from "./hooks/useScrollDirection";

export interface HeaderContextValue {
    /** The CMS data! */
    headerContent: HeaderContent;
    /** Pulled from Reactivated's context */
    favoritesUrl: string | null;
    /** Pulled from Reactivated's context */
    searchUrl: string;
    /**
     * This is for desktop layout submenus + search, which does get used in the
     * mobile nav. Arguably doesn't have to be in here but it's a little cleaner
     */
    activeSubmenu: string | null;
    setActiveSubmenu: (id: string | null) => void;
    /** Mobile nav, burger menu open */
    mobileMenuOpen: boolean;
    setMobileMenuOpen: (open: boolean) => void;
    /**
     * This header uses collision detection to trigger the mobile nav design
     * instead of CSS breakpoints
     */
    isMobileLayout: boolean | null;
    setIsMobileLayout: (value: boolean | null) => void;
    /** Whether the header should render in transparent/overlap mode */
    isOverlapping: boolean;
    /** Used both for overlapping and hide/show on scroll behavior */
    isAtTop: boolean;
    /** The nav hides when scrolling down and shows when scrolling back up */
    scrollDirection: ScrollDirection;
}

export const HeaderContext = React.createContext<HeaderContextValue | null>(
    null,
);

export function useHeaderContext(): HeaderContextValue {
    const context = React.useContext(HeaderContext);
    /* v8 ignore next 3 -- @preserve */
    if (!context) {
        throw new Error("useHeaderContext must be used within a HeaderNav");
    }
    return context;
}
